/* eslint-disable no-nested-ternary */
import { COLORS, colors } from '@constants/colors';
import { SHARED_WINDOW_HEIGHT } from '@constants';
import { useChatState } from '@core/chat/context';

export const useStyles = (
  sharingWindowFullsceen: boolean,
  isOpenChat: boolean,
) => {
  const { chatDrawerWidth } = useChatState();

  return {
    root: {
      width: sharingWindowFullsceen
        ? isOpenChat
          ? `calc(100vw - ${chatDrawerWidth}px) !important`
          : '100vw !important'
        : 400,
      height: sharingWindowFullsceen
        ? '100vh !important'
        : SHARED_WINDOW_HEIGHT,
      position: 'fixed',
      left: sharingWindowFullsceen ? 0 : 'unset',
      right: sharingWindowFullsceen ? 'unset' : 0,
      top: 0,
      zIndex: isOpenChat ? 999999 : sharingWindowFullsceen ? -5 : 6,
      background: COLORS.NEW_BLACK,
      '& video': {
        width: sharingWindowFullsceen
          ? isOpenChat
            ? `calc(100vw - ${chatDrawerWidth}px) !important`
            : '100vw !important'
          : 400,
        height: sharingWindowFullsceen ? '100vh !important' : 225,
      },
      '&:hover': {
        '& button': {
          display: sharingWindowFullsceen ? 'none !important' : 'flex',
        },
        '& p': {
          display: 'flex',
          top: sharingWindowFullsceen ? 60 : 0,
        },
      },
    },
    fullscreen: {
      display: 'none',
      position: 'absolute',
      top: 180,
      right: 70,
      '& svg': {
        color: COLORS.MYTAVERSE_BLUE,
      },
    },
    fullscreenCollapse: {
      display: 'none',
      position: 'absolute',
      top: 180,
      right: 20,
      zIndex: isOpenChat ? 1323 : 343443434334433,
      '& svg': {
        color: colors.myta,
      },
    },
  };
};
